import React from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { emailLogin } from "../../crud/auth.crud";
import { TextField, Grid } from "@material-ui/core";
import { Button} from "react-bootstrap";
// import { values } from "lodash-es";


const initialValues = {
  email: '',
  dateofbirth: '',
};

function LoginEmail(props) {
  const { intl } = props;
  // const [isRequested, setIsRequested] = useState(false);
  const EmailLoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
      dateofbirth: Yup.string().min(10, 'Please enter your date of birth - DD/MM/YYYY').max(10, 'Please enter your date of birth - DD/MM/YYYY').required('Date of Birth (DD/MM/YYYY) is required')      
  });

  return (
    <>
      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title" style={{ marginBottom: 0 }}>
            <h3>
              {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
              Secure Access, Password-Free
            </h3>
            <div className="login-message">
              <p>Enter your email address and birth date and we&apos;ll email you a one-time code to access your account.</p>
            </div>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={EmailLoginSchema}
            onSubmit={(values, { setStatus, setSubmitting }) => {
              setTimeout(() => {
                emailLogin(values.email, values.dateofbirth)
                .then(() => setStatus(intl.formatMessage({ id: "AUTH.VALIDATION.SSO_EMAIL" })))
                .catch((err) => {
                    // disableLoading();
                    setSubmitting(false);
                    if (err)
                    {
                      if (err.response)
                      {
                        if (err.response.data.message && err.response.data.message === 'Login via email is for Clients only')
                        {
                          setStatus(
                            intl.formatMessage({
                              id: "AUTH.VALIDATION.SSO_CLIENTONLY"
                            })
                          );
                        }
                        else
                        {
                          setStatus(
                            intl.formatMessage({
                              id: "AUTH.VALIDATION.SSO_NOTFOUND"
                            })
                          );
                        }
                      }
                      else
                      {
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.SERVER_OUTAGE"
                          })
                        );
                      }
                    }
                    else
                    {
                      setStatus(
                        intl.formatMessage({
                          id: "AUTH.VALIDATION.SERVER_OUTAGE"
                        })
                      );
                    }
                  });
              }, 1000);
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
              >
                {status ? (
                  <>
                    {status === intl.formatMessage({ id: "AUTH.VALIDATION.SSO_EMAIL" }) ? (
                      <div role="alert" className="alert alert-info">
                        <div className="alert-text">{status}</div>
                      </div>
                    ):(
                      <div role="alert" className="alert alert-danger">
                        <div className="alert-text">{status}</div>
                      </div>
                    )}
                  </>
                ) : (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">
                    <i className="far far-warning"></i> Confidential Information - Authorized access only.
                    </div>
                  </div>
                )}

                <div className="login-form login-forgot" style={{ display: "block" }}>
                  <div className="form-group fv-plugins-icon-container">
                <div className="form-group">
                  <TextField
                    variant="outlined"
                    type="email"
                    label="Email"
                    margin="normal"
                    className="kt-width-full"
                    inputProps={{ style: { backgroundColor: "white" }}}
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    helperText={touched.email && errors.email}
                    error={Boolean(touched.email && errors.email)}
                  />
                </div>
                <div className="form-group">
                  <TextField
                    variant="outlined"
                    type="text"
                    label="Date of Birth (DD/MM/YYYY)"
                    margin="normal"
                    className="kt-width-full"
                    inputProps={{ style: { backgroundColor: "white" }}}
                    name="dateofbirth"
                    value={values.dateofbirth}
                    onChange={handleChange}
                    helperText={touched.dateofbirth && errors.dateofbirth}
                    error={Boolean(touched.dateofbirth && errors.dateofbirth)}
                  />
                </div>
                <div className='kt-login__actions'>
                  <Grid container direction="row" justifyContent="space-between">
                    <Grid item md={3}>
                      <Link to="/auth">
                        <Button
                          type="button"
                          id="kt_login_forgot_cancel"
                          variant="secondary"
                        >
                          Cancel
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item md={3}>
                      <Button
                        id="kt_login_forgot_submit"
                        type="submit"
                        variant="primary"
                        disabled={isSubmitting}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </div>
            </div>
          </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(LoginEmail));
